import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';
import { PersonOrganization } from '@src/app/models/personorganization';
import { Projectperson } from '@src/app/models/projectperson';

@Injectable({
  providedIn: 'root'
})
export class StatuschartService {

  serviceUrl:string = environment.apiUrl+'/organization/';
  constructor(private http:HttpClient) { }
 
  getPersonProjects(personId:string){
    // getPersonProjects(personId:string){
       const httpOptions = {
         headers: new HttpHeaders({
           'Content-Type': 'application/json',
           'Authorization': SessionHelper.getIdToken()
         })
       }
       return this.http.get<Projectperson[]>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/projectperson/list/person/'+personId,httpOptions);
      }
}
